// 自定义指令
import Vue from 'vue';
import clickoutside from './clickoutside';
import doubleClickToMaxWin from './doubleClickToMaxWin';
import draggable from './draggable';
import asyncClick from './asyncClick';
import rightClick from './rightClick';
import spaceListHotkey from './spaceListHotkey';
import resizable from './resizable';

// 点击外部操作
Vue.directive('clickoutside', clickoutside);
Vue.directive('doubleClickToMaxWin', doubleClickToMaxWin);
Vue.directive('rightClick', rightClick);
// 预览界面拖动图片
Vue.directive('draggable', draggable);
Vue.directive('asyncClick', asyncClick);
Vue.directive('spaceListHotkey', spaceListHotkey);
Vue.directive('resizable', resizable);
